// src/SimplifiedDeviceActions.js
import React from "react";
import "./SimplifiedDeviceActions.css";

const SimplifiedDeviceActions = ({
  onExecuteAction,
  loadingAction,
  deviceState,
}) => {
  // Determine the lock/unlock button label based on current lock state
  const lockState = deviceState?.lockState?.toLowerCase() || "";
  const isPassage = lockState === "passage";
  const isSecured = lockState === "secured";
  const isFrozenPassage = lockState === "frozen_passage";
  const isFrozenSecured = lockState === "frozen_secured";

  // Determine primary action button label
  let primaryButtonLabel = "Lock";
  let primaryButtonAction = "TOGGLE";

  if (isSecured || isFrozenSecured) {
    primaryButtonLabel = "Unlock";
  } else if (isPassage || isFrozenPassage) {
    primaryButtonLabel = "Lock";
  }

  // Momentary Unlock should be disabled when lock state is Passage
  const isMomentaryUnlockDisabled = isPassage;

  return (
    <div className="simplified-device-actions-container">
      <h2>Device Actions</h2>
      <div className="simplified-actions-buttons">
        <button
          className={`simplified-action-button primary-action ${
            loadingAction === primaryButtonAction ? "working" : ""
          }`}
          onClick={() => onExecuteAction(primaryButtonAction)}
          disabled={!!loadingAction}
        >
          {loadingAction === primaryButtonAction
            ? "Working..."
            : primaryButtonLabel}
        </button>
        <button
          className={`simplified-action-button secondary-action ${
            loadingAction === "PASS_THRU" ? "working" : ""
          }`}
          onClick={() => onExecuteAction("PASS_THRU")}
          disabled={!!loadingAction || isMomentaryUnlockDisabled}
        >
          {loadingAction === "PASS_THRU" ? "Working..." : "Momentary Unlock"}
        </button>
      </div>
    </div>
  );
};

export default SimplifiedDeviceActions;
